import {
  AxialMovementPosition,
  AxialBalanceSignals,
  HealthIndicatorsApi,
  MetricSignalMapping,
  SensorReadings,
  SignalData
} from '@domain/kiln-monitoring'

export const mapToSensorReadings = (data: SignalData[]): SensorReadings =>
  data.reduce((acc, sensor) => {
    if (sensor.localName) {
      acc[sensor.localName] = {
        lastReading: sensor.lastReading,
        lastModelBreach: sensor.lastModelBreach
      }
    }
    return acc
  }, {} as SensorReadings)

export const mapToPositionByPartId = (
  axialBalanceSignals: AxialBalanceSignals | string[] | undefined,
  axialBalanceData: HealthIndicatorsApi['axialBalance'] | undefined
): Record<string, AxialMovementPosition> => {
  if (!axialBalanceSignals || Array.isArray(axialBalanceSignals) || !axialBalanceData) return {}

  return Object.keys(axialBalanceSignals).reduce(
    (acc, key) => {
      const localName = axialBalanceSignals[key]?.signal?.id

      if (localName && axialBalanceData[localName]) {
        acc[key] = axialBalanceData[localName]
      }

      return acc
    },
    {} as Record<string, AxialMovementPosition>
  )
}

export const mapToSignalToSvgMap = (
  sensorMappings: MetricSignalMapping[] | undefined
): Record<string, string> => {
  if (!sensorMappings) return {}

  return sensorMappings.reduce(
    (acc, mapping) => {
      mapping.localNames.forEach((localName) => {
        acc[localName] = mapping.svgId
      })

      return acc
    },
    {} as Record<string, string>
  )
}

export const mapToActiveSections = (
  selectedIds: string[],
  sensorMappings: MetricSignalMapping[] | undefined
): string[] => {
  if (!selectedIds.length || !sensorMappings?.length) return []

  const activeAreas = sensorMappings.reduce((acc, mapping) => {
    const hasSelectedSignal = mapping.localNames.some((localName) =>
      selectedIds.includes(localName)
    )
    if (hasSelectedSignal) {
      acc.add(mapping.svgId)
    }

    return acc
  }, new Set<string>())

  return Array.from(activeAreas)
}
